import React from 'react';
import { ArrowRight, HeartPulse, Briefcase, Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import { specializedPrograms } from '../mock';
import Reveal from './shared/Reveal';
import SectionHeader from './shared/SectionHeader';

const programMeta = {
  1: {
    icon: HeartPulse,
    to: '/nursing-in-germany',
    tag: 'Healthcare careers',
    accent: 'from-brand-500/15'
  },
  2: {
    icon: Briefcase,
    to: '/workforce-management',
    tag: 'Professional growth',
    accent: 'from-navy-500/15'
  }
};

const SpecializedPrograms = () => {
  return (
    <section className="py-20 lg:py-28 bg-navy-50/50">
      <div className="container-x">
        <SectionHeader
          eyebrow="Beyond admissions"
          title={<>Specialized <span className="text-brand-500">programs</span></>}
          subtitle="Purpose-built tracks for healthcare professionals and global careers."
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {specializedPrograms.map((program, index) => {
            const meta = programMeta[program.id];
            const Icon = meta.icon;
            return (
              <Reveal key={program.id} delay={index * 140}>
                <Link
                  to={meta.to}
                  className="card-premium group relative block p-8 lg:p-10 h-full overflow-hidden"
                >
                  <div className={`absolute -top-20 -right-20 w-64 h-64 rounded-full bg-gradient-to-br ${meta.accent} to-transparent blur-2xl group-hover:scale-125 transition-transform duration-500`}></div>

                  <div className="relative">
                    <div className="flex items-center justify-between">
                      <span className="w-14 h-14 rounded-2xl bg-navy-900 text-brand-400 flex items-center justify-center shadow-card group-hover:bg-brand-500 group-hover:text-white transition-colors duration-300">
                        <Icon className="w-7 h-7" />
                      </span>
                      <span className="chip">{meta.tag}</span>
                    </div>

                    <h3 className="mt-6 font-display text-2xl font-bold text-navy-900 group-hover:text-brand-600 transition-colors">
                      {program.title}
                    </h3>
                    <p className="mt-3 text-slate-500 leading-relaxed">{program.description}</p>

                    <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-2.5">
                      {program.features.map((feature) => (
                        <li key={feature} className="flex items-center gap-2.5 text-sm font-medium text-navy-800">
                          <span className="w-5 h-5 rounded-full bg-brand-50 text-brand-600 flex items-center justify-center shrink-0">
                            <Check className="w-3 h-3" />
                          </span>
                          {feature}
                        </li>
                      ))}
                    </ul>

                    <span className="mt-8 inline-flex items-center gap-2 text-sm font-bold text-navy-900 group-hover:text-brand-600 transition-colors">
                      Explore the program
                      <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SpecializedPrograms;
